/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum PreEntityLinkStatus {
  UPDATABLE = 'UPDATABLE',
  NON_UPDATABLE = 'NON_UPDATABLE',
  LINKED = 'LINKED'
}
